import { render, staticRenderFns } from "./EditLocationCatalogue.vue?vue&type=template&id=491bd62a&scoped=true&"
import script from "./EditLocationCatalogue.vue?vue&type=script&lang=ts&"
export * from "./EditLocationCatalogue.vue?vue&type=script&lang=ts&"
import style0 from "./EditLocationCatalogue.vue?vue&type=style&index=0&id=491bd62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491bd62a",
  null
  
)

export default component.exports